import { Star } from "lucide-react";

export function StarRating({ value = 0, size = 18, interactive = false, onChange, testIdPrefix = "star-rating" }) {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className="inline-flex items-center gap-1" role="radiogroup" aria-label="Valutazione">
      {stars.map((n) => {
        const filled = value >= n - 0.5;
        const half = value >= n - 0.5 && value < n;
        return (
          <button
            key={n}
            type="button"
            disabled={!interactive}
            onClick={() => interactive && onChange?.(n)}
            data-testid={`${testIdPrefix}-${n}`}
            className={interactive ? "cursor-pointer transition-transform hover:scale-110" : "cursor-default"}
            aria-label={`${n} stelle`}
          >
            <Star
              size={size}
              strokeWidth={1.5}
              className={filled ? "fill-[#E19A32] stroke-[#E19A32]" : "stroke-[#C8C5BE]"}
              style={half ? { fill: "url(#half)" } : undefined}
            />
          </button>
        );
      })}
    </div>
  );
}

export function StarRatingDisplay({ value = 0, count = 0, size = 16 }) {
  return (
    <div className="inline-flex items-center gap-2">
      <StarRating value={value} size={size} />
      <span className="font-ui text-sm text-[#1A362D] font-medium">{value > 0 ? value.toFixed(1) : "—"}</span>
      {count > 0 && <span className="font-ui text-sm text-[#8A9691]">({count})</span>}
    </div>
  );
}
